if (!customElements.get('product-sticky-atc')) {
  class ProductStickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.js-product-form');
      this.variantInput = this.querySelector('[name="id"]');
      this.submitBtn = this.querySelector('[name="add"]');
      this.priceEl = this.querySelector('[data-sticky-atc-price]');
      this.mediaEl = this.querySelector('[data-sticky-atc-media] img');
      this.drawerOpen = false;
      this.anchorVisible = true;

      this.onVariantChange = this.handleVariantChange.bind(this);
      this.onDrawerOpen = this.handleDrawerOpen.bind(this);
      this.onDrawerClose = this.handleDrawerClose.bind(this);
      this.onResize = this.syncBodyOffset.bind(this);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.anchorVisible = Boolean(entry && entry.isIntersecting);
          this.updateVisibility();
        }, { threshold: 0 });
        this.observeAnchor();
      } else {
        this.anchorVisible = false;
        this.updateVisibility();
      }

      document.addEventListener('on:variant:change', this.onVariantChange);
      document.addEventListener('on:cart-drawer:before-open', this.onDrawerOpen);
      document.addEventListener('on:cart-drawer:after-close', this.onDrawerClose);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('on:variant:change', this.onVariantChange);
      document.removeEventListener('on:cart-drawer:before-open', this.onDrawerOpen);
      document.removeEventListener('on:cart-drawer:after-close', this.onDrawerClose);
      window.removeEventListener('resize', this.onResize);
      document.documentElement.style.removeProperty('--product-sticky-atc-height');
    }

    handleDrawerOpen() {
      this.drawerOpen = true;
      this.updateVisibility();
    }

    handleDrawerClose() {
      this.drawerOpen = false;
      this.updateVisibility();
    }

    observeAnchor() {
      if (this.observer) this.observer.disconnect();
      this.anchor = document.querySelector('[data-product-atc-anchor]');
      if (this.observer && this.anchor) {
        this.observer.observe(this.anchor);
      } else if (!this.anchor) {
        this.anchorVisible = false;
        this.updateVisibility();
      }
    }

    handleVariantChange(evt) {
      this.observeAnchor();

      const variant = evt.detail && evt.detail.variant;
      if (!variant || !this.variantInput) return;

      this.variantInput.value = variant.id;

      if (this.submitBtn) {
        if (variant.available) {
          this.submitBtn.removeAttribute('disabled');
          this.submitBtn.textContent = this.submitBtn.dataset.addToCartText || this.submitBtn.textContent;
        } else {
          this.submitBtn.setAttribute('disabled', 'disabled');
          this.submitBtn.textContent = (window.theme && theme.strings && theme.strings.noStock) || this.submitBtn.textContent;
        }
      }

      const livePrice = document.querySelector('.product-info .js-product-price');
      if (this.priceEl && livePrice) {
        this.priceEl.innerHTML = livePrice.innerHTML;
      }

      const featuredImage = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image);
      if (this.mediaEl && featuredImage && featuredImage.src) {
        this.mediaEl.src = featuredImage.src;
      }
    }

    updateVisibility() {
      const show = !this.anchorVisible && !this.drawerOpen;
      this.classList.toggle('is-visible', show);
      this.classList.toggle('is-drawer-open', this.drawerOpen);

      if (show) {
        this.removeAttribute('inert');
        this.setAttribute('aria-hidden', 'false');
      } else {
        this.setAttribute('inert', '');
        this.setAttribute('aria-hidden', 'true');
      }

      this.syncBodyOffset();
    }

    syncBodyOffset() {
      const height = this.classList.contains('is-visible') ? this.offsetHeight : 0;
      document.documentElement.style.setProperty('--product-sticky-atc-height', `${height}px`);
    }
  }

  customElements.define('product-sticky-atc', ProductStickyAtc);
}

// Hide inline bundle widgets on Stack Radar PDP only; leave post-ATC Bundler funnel popups alone.
(function hideInlineRadarBundleWidgets() {
  const PDP_ROOTS = '.cc-main-product, .cc-featured-product';
  const TITLE = 'Stack Training and Swing Filming Solution';
  const WIDGET_SELECTOR = [
    '.bogos-bundles-widget',
    '.bogos-fbt-upsell-container',
    '.bogos-mix-match-widget',
    '.bundler-target-element',
    '[class*="bndlr"]',
    '[class*="bundler-widget"]',
    '[id*="bundler-widget"]'
  ].join(',');

  function hideNode(el) {
    if (!el || el.closest('.bundles-bundler-hop-full-page-overlay')) return;
    el.hidden = true;
    el.style.setProperty('display', 'none', 'important');
  }

  function hide() {
    document.querySelectorAll(PDP_ROOTS).forEach((root) => {
      root.querySelectorAll(WIDGET_SELECTOR).forEach(hideNode);
      root.querySelectorAll('h1, h2, h3, h4, .h2, .h3').forEach((el) => {
        if (!(el.textContent || '').includes(TITLE)) return;
        hideNode(
          el.closest('.shopify-block, .shopify-app-block, [class*="bogos"], [class*="bundler"], [class*="bndlr"]')
          || el.parentElement
        );
      });
    });
  }

  let scheduled = false;
  function scheduleHide() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      hide();
    });
  }

  hide();
  document.addEventListener('DOMContentLoaded', hide);
  if (typeof MutationObserver === 'undefined') return;
  new MutationObserver(scheduleHide).observe(document.documentElement, { childList: true, subtree: true });
})();

